import { CardSkeleton } from "@ui/components/Card";

export interface DestinationCardSkeletonProps {
  withDescription?: boolean;
}

export function DestinationCardSkeleton({ withDescription }: DestinationCardSkeletonProps) {
  // Destination cards sit tighter than listing cards (`gap-2 lg:gap-2.5` on the real card).
  return <CardSkeleton className="gap-2 md:gap-2 lg:gap-2.5" lines={withDescription ? 2 : 0} />;
}
